import Vue from 'vue';
import QuickFetch from 'quickfetch';
import CustomError from '../CustomError';
import { getUCRedirect, redirectToUC } from '../../uc';
import VueI18n from 'vue-i18n';
import myEn from "@/common/i18n/en-US";
import myZh from "@/common/i18n/zh-CN";
// import VueCookie from "vue-cookie"; // vue-cookie 没有keys方法
import VueCookie from "vue-cookies";
import enLocale from "@jd/element-ui/lib/locale/lang/en";
import zhLocale from "@jd/element-ui/lib/locale/lang/zh-CN";
import JElementUI from "@jd/element-ui/lib/element-ui.common";

Vue.use(VueI18n);

const messages = {
  en: Object.assign({}, myEn, enLocale),
  zh: {
    ...myZh,
    ...zhLocale
  }
};

const i18n = new VueI18n({
  locale: VueCookie.get('jdcloud_sitelang') || 'cn',
  fallbackLocale: 'zh',
  messages, // set locale messages
});

Vue.use(JElementUI, {
  i18n: (key, value) => i18n.t(key, value)
});

const ERROR_HTTP = 'ERROR_HTTP';

const isBadRequest = status => status >= 300;

/**
 * 映射 HTTP 错误时的提示语句
 * @returns {Object}
 */
const badStatusMap = (url) => ({ // eslint-disable-line
  401: '请求未授权!',
  403: '拒绝访问',
  404: '请求资源未找到!',
  415: '请求参数类型错误!',
  500: '服务器内部错误'
});

export default function useBadHTTPMiddleware(r) {
  // bad HTTP request
  const badHTTPMiddleware = r.use(QuickFetch.RESPONSE, async (res, next) => {
    const { status } = res;
    if (isBadRequest(status)) {
      console.log('%c[fetchWrapper] bad HTTP request: status is %s', 'color: red', status);
      if (status === 403) {
        try {
          const json = await res.clone().json(); // clone() is important!
          console.log(json)
          Vue.prototype.$notify.error({
            title:  i18n.t('global.noLimit'),
            message: json.errmsg,
            duration:10000
          })
        } catch (ex) {
          console.log('[fetchWrapper] 402 ERROR: ', ex);
        }
      }else {
        const cookieArr = VueCookie.keys() || [];
        // 没有cookie时，刷新请求返回500，这里判断跳转至登录页
        if (status === 500 && !cookieArr.length) {
            redirectToUC();
        }
        if (status === 402) {
          try {
            const json = await res.clone().json(); // clone() is important!
            console.log(json)
            const ucauthRedict = getUCRedirect({
              status: 402,
              body: JSON.stringify(json)
            });
            if (ucauthRedict) {
              console.log('[fetchWrapper] due to 402, redirecting to uc');
              redirectToUC(ucauthRedict);
            }
          } catch (ex) {
            console.log('[fetchWrapper] 402 ERROR: ', ex);
          }
        }
        const err = new CustomError(ERROR_HTTP, {
          response: res
        });
        next(Promise.reject(err));
        return;
      }
    }
    next(res);
  });

  r.use(QuickFetch.ERROR, (err, next) => {
    if (err.message === ERROR_HTTP) {
      const { status, statusText, url } = err.data.response;
      const message = badStatusMap(url)[status] || statusText;
      if (message) {
        r._errTimeout = setTimeout(() => {
        Vue.prototype.$message.error(message);
        }, 500);
        // console.log(111, r._errTimeout);
      }
    }
    next(err);
  });

  return badHTTPMiddleware;
}



// WEBPACK FOOTER //
// ./src/common/fetchWrapper/middlewares/badHTTP.js